/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SurveyReplacementSourceRankLabel {
    PRIMARY = 'Primary',
    SECONDARY = 'Secondary',
    THIRD = 'Third',
    FOURTH = 'Fourth',
}
